<template>
  <div class="ui stackable grid">
    <div class="ten wide column">
      <div class="ui segment" v-if="isHost">
        <h1 class="ui header">{{ activeQuestion.question }}</h1>
      </div>
      <keyword-panel
        :keywords="keywords"
        @clickedKeyword="markKeyword"
      ></keyword-panel>
    </div>
    <div class="six wide column">
      <div
        class="ui segment"
        v-if="$store.getters.isHost && $store.getters.gameEnded"
      >
        <div
          class="ui icon huge orange fluid button"
          @click.once="showGameOverScreen"
        >
          Eindscherm <i class="right arrow icon"></i>
        </div>
      </div>
      <scoreboard-vertical
        :players="inactivePlayersInFinale"
      ></scoreboard-vertical>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScoreboardVertical from '@/components/elements/scoreboardVertical';
import KeywordPanel from '@/components/elements/keywordPanel';

export default {
  name: 'finale',
  components: { ScoreboardVertical, KeywordPanel },
  computed: {
    ...mapGetters(['isHost']),
    ...mapGetters('finale', ['activeQuestion', 'inactivePlayersInFinale']),
    keywords() {
      return this.$store.getters['finale/activeKeywords'];
    }
  },
  methods: {
    markKeyword(keywordId) {
      this.$store.dispatch('finale/answerQuestion', keywordId);
      this.$store.dispatch('syncGame');
    },
    showGameOverScreen() {
      this.$store.commit('SHOW_GAME_OVER_SCREEN');
      this.$store.dispatch('syncGame');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
